export class UserExcelData {

  private _id:number;
	private _url:string;
  private _name:string;
  
  /**
		* Contructor
		*/
	constructor(id: number, name:string, url: string) {
		this._id = id;
		this._url = url;
		this._name = name;
  }
    
	public get id():number {
		return this._id;
	}
	
	public get url():string {
		return this._url;
	}

	
	public set url(value:string) {
		this._url = value;
	}
	
	
	public get name():string {
		return this._name;
	}
	
	public set name(value:string) {
		this._name = value;
	}
	
	/**
	 * Cleanup 
	 */		
	public cleanup():void {
		
	}
}